const SYSTEM_STATUS_SUMMARY_KEYS = {
  1: 'notIndexed',
  2: 'queued',
  3: 'processing',
  4: 'indexed',
  5: 'failed',
  6: 'needsReindex',
};

const replaceSupplementaryRow = (rows, updatedDocument) =>
  rows.map((document) => (document.id === updatedDocument.id ? { ...document, ...updatedDocument } : document));

const removeSupplementaryRow = (rows, documentId) =>
  rows.filter((document) => document.id !== documentId);

const patchSystemDocumentPage = (pageData, updatedDocument, statusFilter = '') => {
  const isTarget = (document) =>
    document.sourceKind === updatedDocument.sourceKind &&
    document.sourceDocumentId === updatedDocument.sourceDocumentId;
  const existingDocument = pageData.items.find(isTarget);
  if (!existingDocument) return pageData;

  const matchesFilter = statusFilter === '' || String(updatedDocument.status) === String(statusFilter);
  const items = matchesFilter
    ? pageData.items.map((document) => (isTarget(document) ? { ...document, ...updatedDocument } : document))
    : pageData.items.filter((document) => !isTarget(document));
  const summary = { ...pageData.summary };
  const previousSummaryKey = SYSTEM_STATUS_SUMMARY_KEYS[existingDocument.status];
  const nextSummaryKey = SYSTEM_STATUS_SUMMARY_KEYS[updatedDocument.status];

  if (previousSummaryKey !== nextSummaryKey) {
    if (previousSummaryKey && typeof summary[previousSummaryKey] === 'number') {
      summary[previousSummaryKey] = Math.max(0, summary[previousSummaryKey] - 1);
    }
    if (nextSummaryKey && typeof summary[nextSummaryKey] === 'number') {
      summary[nextSummaryKey] += 1;
    }
  }

  const totalItems = matchesFilter ? pageData.totalItems : Math.max(0, pageData.totalItems - 1);
  return {
    ...pageData,
    items,
    summary,
    totalItems,
    totalPages: totalItems === 0 ? 0 : Math.ceil(totalItems / pageData.pageSize),
  };
};

export { patchSystemDocumentPage, removeSupplementaryRow, replaceSupplementaryRow };
